import ComboBoxHeaderComponent from "select-kit/components/combo-box/combo-box-header";
export default ComboBoxHeaderComponent.extend({
  classNames: "future-date-input-selector-header"
});